import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppSettingModule } from '@ds/ng-wt-app-settings';
import { SettingsHelperService } from '../../services/settings-helper.service';

@Component({
  selector: 'ds-setting-login',
  templateUrl: './setting-login.component.html',
  styleUrl: './setting-login.component.scss',
  standalone: true,
  imports: [CommonModule, AppSettingModule],
})
export class SettingLoginComponent implements OnInit {
  isLoginPage = true;
  loginCustomization;
  constructor(private settingHelper: SettingsHelperService) {}
  onLoginBGChanged($event) {
    console.log('onLoginBGChanged', $event);
    this.settingHelper.setLoginSignal($event);
  }
  ngOnInit() {
    this.getLoginBG();
  }
  getLoginBG() {
    let loginCustomization = window.localStorage.getItem('loginBG');
    if (loginCustomization) {
      this.loginCustomization = JSON.parse(loginCustomization);
    }
  }
}
